const initialData = {
  games: [],
  shoutouts: []
};

const games = (state = initialData, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'INITIAL_DATA':
      if (!payload.shoutout) return state || initialData;

      return payload.shoutout || initialData;

    case 'SET_SHOUTOUT':
      return payload;

    case 'ADD_SHOUTOUT_TAB':
      const filteredGames = (state.games || []).filter((x) => {
        return !payload.games.find((y) => y._id === x._id);
      });

      return {
        ...state,
        games: [...payload.games, ...filteredGames]
      };

    case 'UPDATE_GAMES':
      return {
        ...state,
        games: state.games.map((x) => {
          const updatedGame = payload.find((y) => y._id === x._id);
          if (!updatedGame) return x;

          return {
            ...x,
            ...updatedGame
          };
        })
      };

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default games;
